import React from "react";
import PropTypes from "prop-types";
import "./GetBack.css";

export const GetBackToAccount = ({getBack}) => {
  return (<div>
        <button type={"button"} className="get-back additional-padding"
                onClick={getBack}>
          <strong className={"p-md-3"}>&lt; Back</strong>
        </button>
      </div>);
};

GetBackToAccount.propTypes = {
  getBack: PropTypes.func.isRequired,
};